import axios from '../index';

import { ResponseResult, Url } from "../Common/Util";

const GetUrl = Url("api/v1/Inventory/Reports");

export default {
    GetInventoryReportLog,
    GetInventoryReportLogExcel
}

async function GetInventoryReportLog({ protocolId, fromDate, toDate, reportType, expirationDate, releaseId, state, patientNumber, dispensedDate, returnDate, kitNumber, inventoryItemId }) {
    const response = await axios.get(GetUrl('/InventoryLogs'), {
        params: {
            protocolId,
            fromDate,
            toDate,
            reportType,
            expirationDate,
            releaseId,
            state,
            patientNumber,
            dispensedDate,
            returnDate,
            kitNumber,
            inventoryItemId
        }
    })
    return new ResponseResult({ ...response.data });
}

async function GetInventoryReportLogExcel({ protocolId, fromDate, toDate, reportType, expirationDate, releaseId, state, patientNumber, dispensedDate, returnDate, kitNumber, inventoryItemId }) {
    const response = await axios.get(GetUrl('/InventoryLogs/Excel'), {
        params: {
            protocolId,
            fromDate,
            toDate,
            reportType,
            expirationDate,
            releaseId,
            state,
            patientNumber,
            dispensedDate,
            returnDate,
            kitNumber,
            inventoryItemId
        },
        responseType: 'blob'
    })
    return response;
 }